<script setup>
/**
 * Imports
 */
import { enums } from "@/modules/fuel/enums/type.enum";
import { usePlural } from "@/composables";
import { computed } from "vue";

/**
 * Props & Emits
 */
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

/**
 * Variables
 */
const { pluralize } = usePlural();

/**
 * Computed
 */
const compartmentsTooltip = computed(() => {
  const count = props.data?.compartments_count || 0;
  return `${count} ${pluralize(count, "отсек", "отсека", "отсеков")}`;
});

/**
 * Methods
 */

/**
 * Hooks, Watchers
 */
</script>

<template>
  <div class="car-card__tags">
    <span v-if="data.pump" class="car-card__tag car-card__tag--green" v-tooltip.right="'Есть насос'">
      <IconComponent name="pump" category="other" no-fill />
    </span>
    <span
      v-if="data.fuel_type === enums.GAS"
      class="car-card__tag car-card__tag--red"
      v-tooltip.right="'Газ'"
    >
      <IconComponent name="flame" />
    </span>
    <span class="car-card__tag car-card__tag--blue" v-tooltip.right="compartmentsTooltip">
      <IconComponent name="database" />
      <span>{{ data.compartments_count }}</span>
    </span>
  </div>
</template>

<style lang="stylus">
.car-card__tags {
  display flex
  align-items center
  gap: 10px
  z-index: 1
}

.car-card__tag {
  display flex
  align-items center
  gap: 6px
  font-size: 0.875rem
  line-height: normal;

  &--green {
    color: var(--green-2)
  }

  &--red {
    color: var(--red)
  }

  &--blue {
    color: var(--blue)
  }

  .icon {
    width 24px
    height 24px
  }
}
</style>
